import { BaseMapScene } from "./BaseMapScene.js";

export class VillageScene extends BaseMapScene {
  constructor() {
    super("VillageScene", "village");
  }
}
